"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapGridOptions = exports.getFromDefaultColors = exports.getColor = exports.defaultChartColors = exports.CURSOR_BACKGROUND_COLOR = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _colors = _interopRequireDefault(require("../../style/css/shared/colors.json"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var brightColors = ['color-warmup-corn', 'color-coldplay-khaki'];
var defaultChartColors = Object.keys(_colors.default).reverse().filter(function (key) {
  return !brightColors.includes(key);
}).map(function (key) {
  return _colors.default[key];
});
exports.defaultChartColors = defaultChartColors;

var getFromDefaultColors = function getFromDefaultColors(index) {
  return defaultChartColors[index];
};

exports.getFromDefaultColors = getFromDefaultColors;

var getColor = function getColor(colorKey) {
  return _colors.default[colorKey];
};

exports.getColor = getColor;
var CURSOR_BACKGROUND_COLOR = '#a7afbb24';
exports.CURSOR_BACKGROUND_COLOR = CURSOR_BACKGROUND_COLOR;

var mapGridOptions = function mapGridOptions(gridOptions) {
  if (!gridOptions) {
    return;
  }

  var mappedGridOptions = _objectSpread({}, gridOptions);

  var stroke = mappedGridOptions.stroke;
  mappedGridOptions.stroke = stroke && !stroke.startsWith('#') ? getColor(stroke) : stroke;
  return mappedGridOptions;
};

exports.mapGridOptions = mapGridOptions;